export default __webpack_public_path__ + "static/media/bee2.d4d17a51.jpg";